export const EXTENSION_NAME = 'key-value-block'
export const BLOCK_DATA_ATTRIBUTE = 'data-key-value-block'
export const BLOCK_TYPE_DATA_ATTRIBUTE = 'data-key-value-block-type'

export function getContentHTML() {
  return `<div ${BLOCK_TYPE_DATA_ATTRIBUTE}="content">Content Block</div>`
}

export function getBlockHTML() {
  return `<div ${BLOCK_DATA_ATTRIBUTE}="true">
  <div ${BLOCK_TYPE_DATA_ATTRIBUTE}="header">Header</div>
  <div ${BLOCK_TYPE_DATA_ATTRIBUTE}="content">Content Block</div>
</div>`
}
